import { QuestelServicesClient } from '@questelservices/common';
import store from '@/store';
import { FeeSheetRuleDto } from '../models/Fees/FeeSheetRuleDto';
import { InvoiceLineItemDto } from '../models/invoice/InvoiceLineItemDto';
import { ExecutiveSummaryRequestEnum } from '@/models/ExecutiveSummaryRequestEnum';

export class MattersService {
  private client: QuestelServicesClient;

  constructor() {
    this.client = new QuestelServicesClient(store, '/api/matters');
  }

  async getRulesForMatter(matterId: Guid): Promise<FeeSheetRuleDto[]> {
    return await this.client.get(`/${matterId}/fee-sheet-rules`);
  }

  async getLineItems(matterId: Guid): Promise<InvoiceLineItemDto[]> {
    return await this.client.get(`/${matterId}/line-items`);
  }

  public async getMatterBestRulesForOverage(matterId: Guid) {
    return await this.client.get(`/${matterId}/overages/rules`);
  }

  public async getExecutiveSummaryData(matterId: Guid,type:  ExecutiveSummaryRequestEnum ) {
    return await this.client.get(`/${matterId}/executive-summary?type=${type}`);
  }
}
